export default __webpack_public_path__ + "static/media/search.1e51f20b.svg";